import moment from "moment";
import {
  TableCellType,
  TableHeader,
} from "../../../../../components/custom-table/table";
import { AuthStatusOptionModel } from "../../../../../data-model/authStatusOptions";
import { NarAgentGridData } from "../../../../../data-model/medicalPaOrdersModel";
import { NarAgentGridTableColumnKeys } from "../../../../../../shared/enums/tableColumnKeys";
import { formatAuthStatusBadge } from "../../../../../utils/formatAuthStatusBadgeForTable";
import { getLatestRemarkText } from "../../../../../utils/getLatestNarAgentRemark";
import { capitalizeWordsSeperatedByUnderScore } from "../../../../../utils/stringModifications";

export const NarAgentGridTableHeaders: TableHeader[] = [
  {
    label: "Insurance",
    key: NarAgentGridTableColumnKeys.Insurance,
    order: 1,
    width: 9,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Plan",
    key: NarAgentGridTableColumnKeys.Plan,
    order: 2,
    width: 11,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "J Code",
    key: NarAgentGridTableColumnKeys.JCode,
    order: 3,
    width: 8,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Drug Name",
    key: NarAgentGridTableColumnKeys.DrugName,
    order: 4,
    width: 11,
    sortable: true,
    type: TableCellType.STRING,
  },

  {
    label: "Updated At",
    key: NarAgentGridTableColumnKeys.UpdatedAt,
    order: 5,
    width: 9,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Agent Mode",
    key: NarAgentGridTableColumnKeys.AgentMode,
    order: 6,
    width: 8,
    sortable: true,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "Autopass Review",
    key: NarAgentGridTableColumnKeys.AutopassReview,
    order: 7,
    width: 10,
    sortable: true,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "Auth Status",
    key: NarAgentGridTableColumnKeys.AuthStatus,
    order: 8,
    width: 9,
    sortable: true,
    type: TableCellType.BADGE,
  },
  {
    label: "Start Date",
    key: NarAgentGridTableColumnKeys.StartDate,
    order: 9,
    width: 8,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "End Date",
    key: NarAgentGridTableColumnKeys.EndDate,
    order: 10,
    width: 8,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Remarks",
    key: NarAgentGridTableColumnKeys.Remarks,
    order: 11,
    width: 9,
    sortable: true,
    type: TableCellType.STRING_WITH_CUSTOM_TOOLTIP,
  },
];

export const generateNarAgentGridTableData = (
  narAgentGridData: NarAgentGridData[],
  authStatusOptions: AuthStatusOptionModel[] = [],
) => {
  return narAgentGridData.map((data) => ({
    [NarAgentGridTableColumnKeys.Insurance]:
      capitalizeWordsSeperatedByUnderScore(data?.payer ?? ""),
    [NarAgentGridTableColumnKeys.Plan]: data?.line_of_business ?? "",
    [NarAgentGridTableColumnKeys.DrugName]: data?.drug_name ?? "",
    [NarAgentGridTableColumnKeys.JCode]: data?.j_code ?? "",
    [NarAgentGridTableColumnKeys.UpdatedAt]: data?.updated_at
      ? moment(data.updated_at).format("MM/DD/YYYY")
      : "NA",
    [NarAgentGridTableColumnKeys.AgentMode]: {
      id: data?.identifier ?? "",
      defaultChecked: data?.agent_mode === "Agent",
      rowData: data,
      gridIdentifier: NarAgentGridTableColumnKeys.AgentMode,
    },
    [NarAgentGridTableColumnKeys.AutopassReview]: {
      id: data?.identifier ?? "",
      defaultChecked: data?.autopass_review === true,
      rowData: data,
      gridIdentifier: NarAgentGridTableColumnKeys.AutopassReview,
    },
    [NarAgentGridTableColumnKeys.AuthStatus]: formatAuthStatusBadge(
      data?.auth_status,
      authStatusOptions,
    ),
    [NarAgentGridTableColumnKeys.StartDate]: data?.start_date
      ? moment(data.start_date).format("MM/DD/YYYY")
      : "NA",
    [NarAgentGridTableColumnKeys.EndDate]: data?.end_date
      ? moment(data.end_date).format("MM/DD/YYYY")
      : "NA",
    [NarAgentGridTableColumnKeys.Remarks]: {
      displayText: getLatestRemarkText(data?.remarks),
      tooltipText: getLatestRemarkText(data?.remarks),
    },
  }));
};
